import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.7 15.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M0 7.9C0 3.5 3.5 0 7.9 0s7.9 3.5 7.9 7.9-3.5 7.9-7.9 7.9C3.5 15.7 0 12.2 0 7.9m14.7 0c0-3.8-3.1-6.9-6.9-6.9C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9c3.8-.1 6.8-3.1 6.8-6.9m-4.4 3.2L4.7 5.5l.7-.7 5.6 5.6zm-5.6-.7 5.7-5.7.6.7-5.7 5.7z" />
  </svg>
);
const SvgXCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="x-circle" {...props} />;
export default SvgXCircle;
